__turbopack_context__.v({
  "button": "ProductFitSentiment-module-scss-module__rQG2DW__button",
  "fitSentimentContainer": "ProductFitSentiment-module-scss-module__rQG2DW__fitSentimentContainer",
  "fitSentimentSize": "ProductFitSentiment-module-scss-module__rQG2DW__fitSentimentSize",
  "flyOutList": "ProductFitSentiment-module-scss-module__rQG2DW__flyOutList",
  "flyOutSubText": "ProductFitSentiment-module-scss-module__rQG2DW__flyOutSubText",
  "icon": "ProductFitSentiment-module-scss-module__rQG2DW__icon",
});
